import styled from 'styled-components'

export const StyledNavButtons = styled.div`
    display: inline-block;
    padding-right: 5px;
    width: 100%;
`
